export * from './ContratoSlice';
export * from './thunks';